exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ol-loading[data-v-0ad418f4]{display:flex;justify-content:center;align-content:center;align-items:center;flex-flow:column wrap}.ol-loading__image[data-v-0ad418f4]{display:block;position:relative;width:50px;height:50px}.ol-loading__text[data-v-0ad418f4]{display:block;position:relative;font-size:.9em;font-weight:700;margin-top:9px}.ol-loading-enter[data-v-0ad418f4],.ol-loading-leave-active[data-v-0ad418f4]{opacity:0}.ol-loading-enter-container[data-v-0ad418f4],.ol-loading-leave-active-container[data-v-0ad418f4]{-webkit-transform:scale(1.1);transform:scale(1.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ad418f4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/Loading.vue
// module id = 59
// module chunks = 0